import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'pr-add-step-button',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './add-step-button.component.html',
  styleUrls: ['./add-step-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddStepButtonComponent {
  hasSelection = input(false);
  clicked = output();
}
